export enum SearchResultViews {
  Overview = "overview",
  Attribute = "attribute",
  Memo = "memo"
}
